
import Vue from "vue";

import dialogCom from "@/components/ModelCom.vue";
import action from "@/components/ActionBarCom.vue";
import pageCom from "@/components/PageCom.vue";
import DeviceRequestBill from "@/assets/js/Bill/DeviceRequestBill";
import Utils from "@/assets/js/Utils";
import Urls from "@/assets/js/Urls";
import HttpUtil from "@/assets/js/HttpUtil";
export default Vue.extend({
  components: { action, pageCom },
  data() {
    return {
      dialogTableVisible: false,
      total: 0,
      pageSize: 20,
      items: [] as any,
      currentPage: 1,
      currentSid: null as any,
      showImg: false,
      pics: [] as string[],
      sid: null as any,
    };
  },
  mounted() {
    this.currentSid = Utils.getCurrentSid(this.$route.path);
    this.sid = this.$route.query.sid;
    console.log(this.currentSid);
    if (this.currentSid == "12") {
      this.showImg = true;
    }
    this.getList();
  },
  methods: {
    async getList() {
      const actionBar: any = this.$refs.action;
      const content = actionBar.getSearch();
      const array: string[] = ["sanitationPointName", "carNo", "checkInTime"];
      let req: any = await Utils.GetPageReq(
        this.currentPage,
        this.pageSize,
        content,
        array
      );
      const ret: any = await HttpUtil.XCHttpPost(Urls.GetEnvCarLog, req, true, false);
      this.items = ret.data;
      this.total = ret.total;
      console.log(this.items);
    },

    change(val: number, size: number) {
      this.currentPage = val;
      this.pageSize = size;
      this.getList();
    },
    imgClick(pics: string[]) {
      this.pics = pics;
      this.dialogTableVisible = true;
    },
  },
});
